import * as reduxSagaService from './../../../../services/redux-saga';

import * as init from './init';
import watchCustomEvents from './onCustomEvents';

export default reduxSagaService.createRootSaga(
  init.watchCookieConsentIsOk,
  watchCustomEvents
);